import { render } from "./LoadingElement.vue?vue&type=template&id=432a609a&scoped=true"
import script from "./LoadingElement.vue?vue&type=script&lang=js"
export * from "./LoadingElement.vue?vue&type=script&lang=js"

import "./LoadingElement.vue?vue&type=style&index=0&id=432a609a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432a609a"]])

export default __exports__